module.exports = __webpack_public_path__ + "static/media/boink.cf6b0264.webm";